import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusSquareFilledSvg from "@ant-design/icons-svg/es/asn/MinusSquareFilled";
import AntdIcon from '../components/AntdIcon';
var MinusSquareFilled = function MinusSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: MinusSquareFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(MinusSquareFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'MinusSquareFilled';
}
export default RefIcon;